'use client';

import { clsx } from 'clsx';
import React from 'react';

export interface RadioProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  children?: never;
}

export const Radio: React.FC<RadioProps> = ({ className, ...props }) => (
  <input
    // place this here to avoid warnings when it's a complicated controlled component
    onChange={() => {}}
    {...props}
    type="radio"
    className={clsx('form-radio rounded-full focus:ring-0', className)}
  />
);

interface RadioWithLabelProps extends Omit<RadioProps, 'children'> {
  radioClassName?: string;
  children: React.ReactNode;
}

export const RadioWithLabel: React.FC<RadioWithLabelProps> = ({
  radioClassName,
  children,
  className,
  ...props
}) => {
  return (
    <label className={clsx('flex space-x-2', className)}>
      <Radio {...props} className={clsx(radioClassName, 'mt-1.5')} />
      <span>{children}</span>
    </label>
  );
};
